import { InjectionToken } from '@angular/core';

export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

export interface WebPushConfig {
  firebase: FirebaseConfig;
  vapidKey: string;
}

export const WEB_PUSH_CONFIG = new InjectionToken<WebPushConfig>(
  'WEB_PUSH_CONFIG'
);
